"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKLoading = void 0;
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var clsx_1 = require("clsx");
var common_1 = require("../../common");
var _1 = require(".");
var GKProgressBar_1 = require("../GKProgressBar");
var GKSpinner_1 = require("./GKSpinner");
var GKLoading_models_1 = require("./GKLoading.models");
require("./GKLoading.css");
var GKLoading = function (props) {
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-loading",
    }), children = _a.children, className = _a.className, dataQa = _a["data-qa"], inline = _a.inline, isLoading = _a.isLoading, overlay = _a.overlay, type = _a.type, spinnerProps = _a.spinnerProps, progressBarProps = _a.progressBarProps, value = _a.value, otherProps = __rest(_a, ["children", "className", "data-qa", "inline", "isLoading", "overlay", "type", "spinnerProps", "progressBarProps", "value"]);
    var classes = (0, clsx_1.clsx)(className, {
        "gk-is-inline": inline,
        "gk-has-overlay": overlay,
        "gk-is-loading": isLoading,
    });
    // Refs used by the CSSTransition component
    var loadingRef = react_1.default.useRef(null);
    var completedRef = react_1.default.useRef(null);
    var currentRef = isLoading ? loadingRef : completedRef;
    var childArray = react_1.default.Children.toArray(children);
    var loadingChildren = childArray.filter(function (child) { return child.type === _1.GKLoadingState; });
    if (type === GKLoading_models_1.GKLoadingType.Spinner) {
        loadingChildren.push(react_1.default.createElement(GKSpinner_1.GKSpinner, __assign({}, spinnerProps, { key: "spinner", value: value, "data-qa": dataQa + "--spinner" })));
    }
    if (type === GKLoading_models_1.GKLoadingType.Bar) {
        loadingChildren.push(react_1.default.createElement(GKProgressBar_1.GKProgressBar, __assign({}, progressBarProps, { key: "progress", value: value, "data-qa": dataQa + "--progress" })));
    }
    var completedChildren = childArray.filter(function (child) { return child.type === _1.GKCompletedState; });
    var neitherChildren = childArray.filter(function (child) {
        return child.type !== _1.GKLoadingState && child.type !== _1.GKCompletedState;
    });
    /**
     * Note: we're deliberately using timeout instead of addEndListener here.
     * While addEndListener is cleaner, but the transitionend event does not ever trigger
     * if the parent/ancestor element of GKLoading is set to display: none (eg, if it
     * is within a tab pane that is not active).
     */
    return (react_1.default.createElement(react_transition_group_1.SwitchTransition, null,
        react_1.default.createElement(react_transition_group_1.CSSTransition, { key: isLoading ? "loading" : "completed", classNames: "animate", nodeRef: currentRef, timeout: 150 },
            react_1.default.createElement("div", __assign({}, otherProps, { "data-qa": dataQa, ref: currentRef, className: classes }),
                isLoading ? loadingChildren : completedChildren,
                neitherChildren))));
};
exports.GKLoading = GKLoading;
